// Shared treatment metadata: keys map to translation keys, URL slugs and images.
// Images are stored locally under /public/treatments/ to avoid any dependency
// on the old WordPress CDN (which now returns 404 across the board).

const IMG = (file) => `/treatments/${file}`;

export const TREATMENTS = [
  {
    key: "botox",
    slug: "faltenbehandlung",
    hero: IMG("botox.jpg"),
    gallery: [IMG("botox.jpg"), IMG("skincare.jpg"), IMG("nano.jpg")],
  },
  {
    key: "hyaluron",
    slug: "hialuronico",
    hero: IMG("hyaluron.jpg"),
    gallery: [IMG("hyaluron.jpg"), IMG("skincare.jpg"), IMG("sculptra.jpg")],
  },
  {
    key: "nano",
    slug: "nanoneedling",
    hero: IMG("nano.jpg"),
    gallery: [IMG("nano.jpg"), IMG("skincare.jpg"), IMG("hyaluron.jpg")],
  },
  {
    key: "lippen",
    slug: "labios",
    hero: IMG("lippen.jpg"),
    gallery: [IMG("lippen.jpg"), IMG("hyaluron.jpg"), IMG("skincare.jpg")],
  },
  {
    key: "sculptra",
    slug: "sculptra",
    hero: IMG("sculptra.jpg"),
    gallery: [IMG("sculptra.jpg"), IMG("skincare.jpg"), IMG("hyaluron.jpg")],
  },
];

export const getTreatmentBySlug = (slug) =>
  TREATMENTS.find((t) => t.slug === slug);
